<template>
  <svg
    width="17"
    height="19"
    viewBox="0 0 17 19"
  >
    <path d="M15.7159 10.7045C16.1036 10.3111 16.0989 9.67795 15.7055 9.29033C15.3121 8.90271 14.6789 8.9074 14.2913 9.3008L8.99996 14.6711V1C8.99996 0.447715 8.55224 0 7.99996 0C7.44767 0 6.99996 0.447716 6.99996 1V14.6646L1.71501 9.3008C1.32739 8.9074 0.694241 8.90271 0.300835 9.29033C-0.0925711 9.67795 -0.0972593 10.3111 0.290362 10.7045L7.11275 17.6287C7.60236 18.1256 8.40395 18.1256 8.89356 17.6287L15.7159 10.7045Z" />
  </svg>
</template>
